import { useSelector } from "react-redux";

import { admin_cse } from "@/config/roles";
import { isAuthorized } from "@/utils/authToken";
import { selectProfileUsername } from "@/redux/selectors/authSelectors";
import { useCosignatureSupervisors } from "@/features/cosignature/api/queries/useCosignatureSupervisors";

export function useCosignSupervisor() {
  const username = useSelector(selectProfileUsername);
  const { data: supervisors, isLoading } = useCosignatureSupervisors({
    enabled: isAuthorized(admin_cse),
  });

  return {
    isLoading,
    isSupervisor: isAuthorized(admin_cse) && (supervisors?.some((s) => s.id === username) ?? false),
  };
}
